module.exports = __webpack_public_path__ + "static/media/Kalaallit_2026_PDF.b1d3261e.pdf";